import { all, fork } from "redux-saga/effects";
import LoginSagas from "./auth/login/sagas";
import LogoutSagas from "./auth/logout/sagas";
import ClientSagas from "./auth/client/sagas";
import AuthSagas from "./auth/user/sagas";
import StateSagas from "./state/sagas";
import UserSagas from "./user/sagas";
import CitySagas from "./city/sagas";
import IdentificationTypeSagas from "./identificationType/sagas";
import DocumentTypeSagas from "./documentType/sagas";
import OnerosoSagas from './oneroso/sagas';
import NaturalPerson from './naturalPerson/sagas';
import LegalPerson from './legalPerson/sagas';
import FamilyMember from './familyMember/sagas';
import SupplementaryData from './supplementaryData/sagas';
import DocumentSagas from "./document/sagas";
import CreditSagas from "./credit/sagas";
import ClientsSagas from "./client/sagas";
import ConfigurationSagas from "./configuration/sagas";
import SureTypeFeatureSagas from "./sureTypeFeature/sagas";
import InsuranceSagas from "./insurance/sagas";
import SureTypeSagas from "./sureType/sagas";
import FeatureSagas from "./feature/sagas";
import PolicySagas from "./policy/sagas";
import SmsSagas from "./sms/sagas";
import PaymentPlanSagas from "./paymentPlan/sagas";
import AuditSagas from "./audit/sagas";
import EmailNotificationSagas from "./emailNotification/sagas";

export function* IndexSagas() {
	yield all([
		fork(LoginSagas),
		fork(LogoutSagas),
		fork(ClientSagas),
		fork(AuthSagas),
		fork(StateSagas),
		fork(UserSagas),
		fork(CitySagas),
		fork(IdentificationTypeSagas),
		fork(DocumentTypeSagas),
		fork(OnerosoSagas),
		fork(NaturalPerson),
		fork(LegalPerson),
		fork(FamilyMember),
		fork(SupplementaryData),
		fork(DocumentSagas),
		fork(CreditSagas),
		fork(ClientsSagas),
		fork(ConfigurationSagas),
		fork(SureTypeFeatureSagas),
		fork(InsuranceSagas),
		fork(SureTypeSagas),
		fork(FeatureSagas),
		fork(PolicySagas),
		fork(SmsSagas),
		fork(PaymentPlanSagas),
		fork(AuditSagas),
		fork(EmailNotificationSagas)
	]);
}